// import React, { useEffect, useState } from 'react';
// import { Card, CardTitle, CardBody, Button, Table, Input } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import useVendorBranch from '../../utils/useVendorBranch';

// const CourseExamSubPatternList = () => {
//   const { user } = useSelector((state) => state.authState);
//   const navigate = useNavigate();

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [errorMessage, setErrorMessage] = useState({});
//   const [list, setList] = useState([]);

//   // same like FeeHead / WeekendList: start empty
//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const [filters, setFilters] = useState({
//     courseId: '',
//     patternId: '',
//     subjectId: '',
//     search: '',
//   });

//   const onHandleAdd = () => {
//     navigate('/save-cour-sub-exam-pattern');
//   };

//   const onHandleEdit = (id) => {
//     const selected = list.find((x) => x.id === id);
//     navigate('/save-cour-sub-exam-pattern', { state: { ...(selected || {}) } });
//   };

//   const GetList = async () => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       const courseId = filters.courseId || '';
//       const patternId = filters.patternId || '';
//       const subjectId = filters.subjectId || '';
//       const search = filters.search || '';

//       // ✅ NOTE: aapke controller me agar GET method abhi add nahi hai,
//       // to is URL ko apne available GET endpoint se replace kar do.
//       const res = await apiService.get(
//         `api/ExamMaster/GetAllCourseExamSubPattern?vendorId=${vendorId}&branchId=${branchId}&courseId=${courseId}&patternId=${patternId}&subjectId=${subjectId}&search=${encodeURIComponent(
//           search
//         )}`
//       );

//       if (res?.status === true) {
//         setList(res.data || []);
//       } else {
//         alert(res?.message || 'Failed');
//       }
//     } catch (e) {
//       console.error(e);
//       alert('Something went wrong');
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) {
//       GetList();
//     }
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   return (
//     <>
//       <div className='d-flex justify-content-between align-items-center mb-2'>
//         <Button color='primary' onClick={onHandleAdd}>
//           <i className='bi bi-plus-circle' /> Add Subject Pattern
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='p-3 mb-0'>
//           <i className='bi bi-list-check mr-2' /> Course Exam Sub Pattern
//         </CardTitle>

//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Edit</th>
//                 <th>Course</th>
//                 <th>Pattern</th>
//                 <th>Subject</th>
//                 <th>Max Marks</th>
//                 <th>Passing Marks</th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.length > 0 ? (
//                 list.map((x, i) => (
//                   <tr key={x.id}>
//                     <td>{i + 1}</td>
//                     <td>
//                       <i
//                         className='bi bi-pencil text-primary'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleEdit(x.id)}
//                       />
//                     </td>
//                     <td>{x.course_id}</td>
//                     <td>{x.pattern_id}</td>
//                     <td>{x.subject_id}</td>
//                     <td>{x.max_marks}</td>
//                     <td>{x.passing_marks}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan='7' className='text-center'>
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default CourseExamSubPatternList;

//SignalR
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Card, CardTitle, CardBody, Button, Table, Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'CourseExamSubPattern';

const CourseExamSubPatternList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [list, setList] = useState([]);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [filters, setFilters] = useState({
    courseId: '',
    patternId: '',
    subjectId: '',
    search: '',
  });

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAdd = () => {
    navigate('/save-cour-sub-exam-pattern');
  };

  const onHandleEdit = (id) => {
    const selected = list.find((x) => x.id === id);
    navigate('/save-cour-sub-exam-pattern', { state: { ...(selected || {}) } });
  };

  const GetList = useCallback(async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const courseId = filters.courseId || '';
      const patternId = filters.patternId || '';
      const subjectId = filters.subjectId || '';
      const search = filters.search || '';

      const res = await apiService.get(
        `api/ExamMaster/GetAllCourseExamSubPattern?vendorId=${vendorId}&branchId=${branchId}&courseId=${courseId}&patternId=${patternId}&subjectId=${subjectId}&search=${encodeURIComponent(search)}`
      );

      if (res?.status === true) {
        setList(res.data || []);
      } else {
        setList([]);
        alert(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      alert('Something went wrong');
      setList([]);
    }
  }, [selectionData.vendor_id, selectionData.branch_id, filters]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      GetList();
    }
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData.vendor_id || 0;
        const branchId = selectionData.branch_id || 0;
        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);
          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted || !payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor = String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch = String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            GetList();
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) setupSignalR();

    return () => {
      mounted = false;
    };
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetList,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();
      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(console.error);
      }
    };
  }, []);

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Subject Pattern
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-list-check mr-2' /> Course Exam Sub Pattern
        </CardTitle>

        <div className='p-2'>
          <Input
            placeholder='Search...'
            value={filters.search}
            onChange={(e) =>
              setFilters((p) => ({ ...p, search: e.target.value }))
            }
          />
        </div>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Course</th>
                <th>Pattern</th>
                <th>Subject</th>
                <th>Max Marks</th>
                <th>Passing Marks</th>
              </tr>
            </thead>
            <tbody>
              {list.length > 0 ? (
                list.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>
                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.id)}
                      />
                    </td>
                    <td>{x.course_id}</td>
                    <td>{x.pattern_id}</td>
                    <td>{x.subject_id}</td>
                    <td>{x.max_marks}</td>
                    <td>{x.passing_marks}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='7' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default CourseExamSubPatternList;